import React from 'react';
import { Box, Button, Typography, Paper } from '@mui/material';
import { useAuth } from '../contexts/AuthContext';
// Logo served from Vite public directory

const Login: React.FC = () => {
  const { login } = useAuth();

  return (
    <Box
      sx={{
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        height: '100vh',
        width: '100vw',
        position: 'fixed',
        top: 0,
        left: 0,
        right: 0,
        bottom: 0,
      }}
    >
      <Paper elevation={3} sx={{ p: 4, maxWidth: 420, width: '100%', textAlign: 'center' }}>
        <Box sx={{ mb: 3, display: 'flex', justifyContent: 'center' }}>
          <img
            src="/brandtrax-logo.png"
            alt="BrandTrax Logo"
            style={{
              height: 60,
              width: 'auto',
              maxWidth: '100%',
            }}
          />
        </Box>
        <Typography variant="h5" gutterBottom>
          Sign in to Collector
        </Typography>
        <Button variant="contained" color="primary" onClick={login} fullWidth>
          Login with Azure
        </Button>
      </Paper>
    </Box>
  );
};

export default Login;
